"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ts_validators_1 = require("ts-validators");
const controlIsLegacy = (control) => {
    if (!control || (0, ts_validators_1.valueIsString)(control)) {
        return false;
    }
    return true;
};
exports.default = controlIsLegacy;
